<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid class="compact-container">
        <!-- Logo no topo -->
        <v-row justify="center" class="mb-4">
          <v-col cols="12" class="text-center">
            <v-img
              v-if="igreja && igreja.logoUrl"
              :src="igreja.logoUrl"
              max-width="180"
              class="logo-top mx-auto"
              contain
            ></v-img>
            <v-progress-circular
              v-else
              indeterminate
              color="white"
              size="40"
            ></v-progress-circular>
          </v-col>
        </v-row>

        <v-row align="center" justify="center" dense>
          <v-col cols="12" sm="6" md="4" lg="4" v-for="(item, idx) in menuItems" :key="idx" class="d-flex">
            <v-card dark class="menu-card compact-card" :style="item.style">
              <div class="pa-3">
                <v-card-title class="text-h6 font-weight-bold compact-title">
                  <v-icon left size="22">{{ item.icon }}</v-icon>
                  {{ item.title }}
                </v-card-title>
                <v-card-subtitle class="mt-1 compact-subtitle">{{ item.subtitle }}</v-card-subtitle>
                <v-card-actions class="mt-2">
                  <component :is="item.linkType" v-bind="item.linkProps">
                    <v-btn height="36px" outlined block class="font-weight-bold compact-btn">{{ item.btnText }}</v-btn>
                  </component>
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div class="login-title mt-4">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="140px">
          </a>
        </div>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout" color="success">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import { mapState } from 'vuex'
  import axios from 'axios'
  export default {
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        idIgreja: '6390de5538a3bc18300a2022',
        igreja: {},
        isLoading: false,
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
        menuItems: [
          {
            title: 'Recadastramento',
            icon: 'mdi-account-plus',
            subtitle: 'Para você que deseja se tornar membro ou frequenta a Igreja da Liberdade',
            btnText: 'Cadastrar',
            linkType: 'router-link',
            linkProps: { to: '/liberdadercad', style: 'text-decoration: none; color: white' },
            style: 'background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%); border-radius: 16px;'
          },
          {
            title: 'Visitante',
            icon: 'mdi-account-plus',
            subtitle: 'Para você que está vindo pela primeira vez na Igreja da Liberdade',
            btnText: 'Cadastrar',
            linkType: 'router-link',
            linkProps: { to: '/liberdade', style: 'text-decoration: none; color: white' },
            style: 'background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%); border-radius: 16px;'
          },
          {
            title: 'Culto infantil',
            icon: 'mdi-church',
            subtitle: 'Confirme a participação de seus filhos nos cultos infantis da Igreja da Liberdade',
            btnText: 'Acessar',
            linkType: 'router-link',
            linkProps: { to: '/ilkids', style: 'text-decoration: none; color: white' },
            style: 'background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%); border-radius: 16px;'
          },
          {
            title: 'Profissionais',
            icon: 'mdi-account-hard-hat',
            subtitle: 'Para você que é membro da Liberdade e deseja se cadastrar como profissional para que possam lhe contratar',
            btnText: 'Cadastrar',
            linkType: 'router-link',
            linkProps: { to: '/liberdadeprofissionais', style: 'text-decoration: none; color: white' },
            style: 'background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%); border-radius: 16px;'
          },
          {
            title: 'Catálogo de profissionais',
            icon: 'mdi-book-open-blank-variant',
            subtitle: 'Encontre um profissional membro da Liberdade para realizar seu serviço',
            btnText: 'Buscar',
            linkType: 'router-link',
            linkProps: { to: '/liberdadecatalogo', style: 'text-decoration: none; color: white' },
            style: 'background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%); border-radius: 16px;'
          },
          {
            title: 'Me voluntariar',
            icon: 'mdi-hand-heart',
            subtitle: 'Para você que é membro da Liberdade e deseja se voluntariar',
            btnText: 'Buscar',
            linkType: 'router-link',
            linkProps: { to: '/voluntario', style: 'text-decoration: none; color: white' },
            style: 'background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%); border-radius: 16px;'
          },
          {
            title: 'Calendário',
            icon: 'mdi-calendar',
            subtitle: 'Agenda de eventos da Igreja da Liberdade',
            btnText: 'Ver',
            linkType: 'a',
            linkProps: { href: 'https://calendar.google.com/calendar/embed?src=bvn518l7rtn95s2tab9c3moqjk%40group.calendar.google.com&ctz=America%2FFortaleza', target: '_blank', style: 'text-decoration: none; color: white' },
            style: 'background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%); border-radius: 16px;'
          },
          {
            title: 'Escola Ministerial',
            icon: 'mdi-school',
            subtitle: 'Para você que é membro e deseja se inscrever na Escola Ministerial',
            btnText: 'Inscrever',
            linkType: 'router-link',
            linkProps: { to: '/liberdadeem', style: 'text-decoration: none; color: white' },
            style: 'background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%); border-radius: 16px;'
          },
        ]
      }
    },

    mounted: function () {
      this.carregaDados()
    },

    methods: {
      async carregaDados() {
        this.isLoading = true
        try {
          const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
          if (response.data) {
            this.igreja = response.data
          }
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Erro ao carregar dados da igreja.'
        } finally {
          this.isLoading = false
        }
      },
      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },
    }
  }
</script>

<style scoped>
  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: #fff;
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .logo-top {
    margin-bottom: 10px;
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.08));
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 20px;
    background-color: #fff;
    opacity: 0.95;
    padding: 20px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.1);
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .menu-card {
    transition: transform 0.3s ease;
    height: 100%;
  }

  .menu-card:hover {
    transform: translateY(-5px);
  }

  .v-card__title {
    font-size: 1.25rem !important;
    line-height: 1.5 !important;
  }

  .v-card__subtitle {
    font-size: 0.9rem !important;
    line-height: 1.4 !important;
    opacity: 0.9;
  }

  .v-btn {
    text-transform: none !important;
    letter-spacing: 0.5px !important;
  }

  .compact-container {
    padding: 0 4vw 0 4vw;
    max-width: 700px;
    margin: 0 auto;
  }

  .menu-card.compact-card {
    min-height: 180px;
    margin-bottom: 16px;
    box-shadow: 0 8px 24px rgba(0, 105, 92, 0.18) !important;
    border-radius: 16px !important;
  }

  .compact-title {
    font-size: 1.05rem !important;
    line-height: 1.3 !important;
  }

  .compact-subtitle {
    font-size: 0.85rem !important;
    line-height: 1.2 !important;
    opacity: 0.85;
  }

  .compact-btn {
    font-size: 0.95rem !important;
    height: 36px !important;
    min-width: 90px;
    padding: 0 8px;
    border-radius: 999px !important;
  }

  .login-title {
    margin-top: 10px;
    text-align: center;
  }
</style>
